import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import StatusMessageBox from 'components/StatusMessageBox';

const AddDeviceGroupSuccess: FC = () => {
  const { t } = useTranslation();

  return (
    <StatusMessageBox
      type="success"
      message={t(
        'common:pages.device_groups.add_device_group.group_added_successfully',
      )}
    />
  );
};

export default AddDeviceGroupSuccess;
